import React, { useEffect, useState, useContext } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Row, Col, Button, Spinner } from 'react-bootstrap'
import { taskDetail, listTechnician, taskStatus, assignTechnician, cancelTask, deleteTask, unassign, getPdf } from '../Network/Repair'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { ModalContext } from '../Library/ModalContext'
import { Loading, HeaderTitle, ImagePreview, UserProfileImage } from '../Library'
import "./RepairDetail.css"
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faTimesCircle, faCheckCircle, faUserCircle, faAsterisk, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'
import { AlertModalContext } from '../Library/AlertModalContext'

function RepairDetail() {
    const modal = useContext(ModalContext)
    const alertModal = useContext(AlertModalContext)
    const notifyCx = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.repair_service
    const errorLang = langCx.lang.error
    const history = useHistory()
    const { id } = useParams()
    const [isLoading, setLoading] = useState(false)
    const [isMiniLoading, setMiniLoading] = useState(false)
    const [detail, setDetail] = useState({
        issueType: "",
        issueTypeId: "",
        line: "",
        location: "",
        officePhone: "",
        phone: "",
        progressDate: "",
        quantity: "",
        remark: "",
        repairType: "",
        repairTypeId: "",
        room: "",
        status: "",
        technicianId: "",
        technicianName: "",
        technicianEmail: "",
        telephone: "",
        ticketName: "",
        userId: 2,
        username: "",
        floor: "",
        zone: "",
        technicianProfileImage: "",
        userProfileImage: "",
        images: []
    })
    const [technicianList, setTechnicianList] = useState([])
    const [selectedTechnician, setSelectedTechnician] = useState("");

    const fetchData = ()=>{
        setLoading(true)
        taskDetail(id,
            (data)=>{
                setDetail(data)
                if(data.status === taskStatus.CREATE){
                    fetchTechnicianList()
                }
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
                history.push("/repair")
            })
    }

    const fetchTechnicianList = () =>{
        setMiniLoading(true)
        listTechnician(
            (data)=>{
                setMiniLoading(false)
                setTechnicianList(data)
            },
            (error)=>{
                setMiniLoading(false)
                notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
            }
        )
    }

    const assignTech = () =>{
        setMiniLoading(true)
        assignTechnician(selectedTechnician, id,
            ()=>{
                setMiniLoading(false)
                fetchData()
                notifyCx.showNotify(lang.assign_success,
                lang.assign_success_desc, 
                0)
            },
            (error)=>{
                setMiniLoading(false)
                notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
            })
    }

    const cancel = () =>{
        alertModal.setTitle(lang.cancel)
        alertModal.setDescription(lang.cancel_sure)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                    setLoading(true)
                    cancelTask(id,
                        ()=>{
                            setLoading(false);
                            fetchData();
                        },
                        (error)=>{
                            setLoading(false)
                            notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        // if(window.confirm(lang.cancel_sure)){
        //     setLoading(true)
        //     cancelTask(id,
        //         ()=>{
        //             setLoading(false);
        //             fetchData();
        //         },
        //         (error)=>{
        //             setLoading(false)
        //             notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
        //         })
        // }
    }

    const deleteThisTask = () =>{
        alertModal.setTitle(lang.delete)
        alertModal.setDescription(lang.delete_sure)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    deleteTask(id,
                        ()=>{
                            setLoading(false)
                            history.push("/repair")
                        },
                        (error)=>{
                            setLoading(false)
                            notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        // if(window.confirm(lang.delete_sure)){
        //     setLoading(true)
        //     deleteTask(id,
        //         ()=>{
        //             setLoading(false)
        //             history.push("/repair")
        //         },
        //         (error)=>{
        //             setLoading(false)
        //             notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
        //         })
        // }
    }

    const unassignFromTask = () =>{
        alertModal.setTitle(lang.unassign)
        alertModal.setDescription(lang.unassign_desc1 + " " + detail.technicianName + " " + lang.unassign_desc2)
        alertModal.setAlertType("WARNING")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "primary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    unassign(id,
                        ()=>{
                            setLoading(false)
                            fetchData()
                        },
                        (error)=>{
                            setLoading(false)
                            notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        // if(window.confirm(lang.unassign_desc1 + " " + detail.technicianName + " " + lang.unassign_desc2)){
        //     setLoading(true)
        //     unassign(id,
        //         ()=>{
        //             setLoading(false)
        //             fetchData()
        //         },
        //         (error)=>{
        //             setLoading(false)
        //             notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
        //         })
        // }
    }

    const downloadPdf = () =>{
        setLoading(true)
        console.log(id)
        getPdf(id,
            (path)=>{
                setLoading(false)
                const pdfWindow = window.open()
                pdfWindow.location.href = path
            },
            (error)=>{
                setLoading(false)
                console.log(error.response)
                notifyCx.showNotify(errorLang.something_wrong, error.message, 2)
            })
    }

    const previewImage = (key) =>{

        modal.setComponent(
            <ImagePreview
            imagesSet={detail.images}
            initialKey={key}
            />
        )
        modal.setHeader(lang.attach_image)
        modal.setShowHeader(true)
        modal.setDark(true)
        modal.setShow(true)
    }

    useEffect(() => {
        setDocumentTitle("Repair Detail")
        fetchData()
    }, [])

    let statusIcon
    let statusColor
    let statusText

    switch (detail.status) {
        case(taskStatus.CREATE):
            statusIcon = faAsterisk
            statusColor = "orange"
            statusText = lang.created
            break;
        case(taskStatus.WAITING):
            statusIcon = faClock
            statusColor = "orange"
            statusText = lang.waiting
            break;
        case(taskStatus.IN_PROGRESS):
            statusIcon = faClock
            statusColor = "#3a88bc"
            statusText = lang.in_progress
            break;
        case(taskStatus.COMPLETE):
            statusIcon = faCheckCircle
            statusColor = "green"
            statusText = lang.complete
            break;
        case(taskStatus.CANCEL):
            statusIcon = faTimesCircle
            statusColor = "red"
            statusText = lang.cancelled
            break;
        default:
            statusIcon = faQuestionCircle
            statusColor = "gray"
            statusText = "No status"
            break;
    }

    return (
        <>
        { isLoading ? <Loading title="Loading detail"/> : null }
        <div id="repair-detail">
            {/* <div className="title-header">
                <FontAwesomeIcon icon={statusIcon} 
                style={{color: statusColor, marginRight: 15}}/>
                {detail.ticketName}
            </div> */}
            <HeaderTitle
            title={
                <div>
                    <FontAwesomeIcon icon={statusIcon} 
                    style={{color: statusColor, marginRight: 15}}/>
                    {detail.ticketName}
                </div>
            }
            isShowBack
            backTo="/repair"
            />
            <div>
                <Row>
                    <Col lg={6}>
                        <div className="col-container">
                            <div className="col-title">{lang.task_detail}</div>
                            <DetailRow title={lang.status} detail={statusText}/>
                            <DetailRow title={lang.branch} detail={detail.branch}/>
                            <DetailRow title={lang.service_type} detail={detail.repairType}/>
                            <DetailRow title={lang.issue_type} detail={detail.issueType}/>
                            <DetailRow title={lang.quantity} detail={detail.quantity}/>
                            <DetailRow title={lang.Area} detail={detail.room}/>
                            <DetailRow title={lang.telephone_affect} detail={detail.telephone}/>
                            <DetailRow title={lang.detail} detail={detail.remark}/>
                            <DetailRow title={lang.name} detail={detail.username}/>
                            <DetailRow title={lang.company} detail={detail.company}/>
                            <DetailRow title={lang.office_phone} detail={detail.officePhone}/>
                            <DetailRow title={lang.floor} detail={detail.floor}/>
                            <DetailRow title={lang.zone} detail={detail.zone}/>
                            <DetailRow title={lang.datetime} detail={dayjs(new Date(detail.createdDate)).format("D MMMM YYYY - HH:mm")}/>
                        </div>
                        <div className="image-container">
                            <div className="col-title" style={{ marginBottom: 13 }}>{lang.attach_image}</div>
                            { detail.images.length > 0 ?
                            <Row>
                                { detail.images.map((item, key)=>
                                <Col xs={6} sm={4} lg={6} xl={4} key={key}>
                                    <img src={item.imagePath} 
                                    className="image-thumbnail" 
                                    onClick={()=>{
                                        previewImage(key)
                                    }}/>
                                </Col>
                                )}
                            </Row>
                            :
                            <div>
                                {lang.no_attach}
                            </div>
                            }
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="col-container">
                            { detail.status === taskStatus.CREATE ? 
                            <>
                            <div className="assign-title">
                                <div>
                                    <div className="col-title">{lang.assign}</div>
                                    <div className="col-desc">{lang.assign_desc}</div>
                                </div>
                                <div>
                                    { isMiniLoading ?
                                    <Spinner 
                                    variant="primary" 
                                    animation="border"/>
                                    : null
                                    }
                                </div>
                            </div>
                            <div className="technician-container">
                                <Row>
                                { technicianList.filter(el => el.position == 'Technician').map((item, key)=> 
                                    <Col xs={6} md={4} lg={6} xl={4} key={key}>
                                        <TechnicianProfile
                                        id={item.id}
                                        isSelected={item.id === selectedTechnician ? true:false}
                                        name={item.firstName + " " + item.lastName}
                                        imagePath={item.profileImagePath}
                                        onClick={(e)=>setSelectedTechnician(item.id)}
                                        />
                                    </Col>
                                
                                )}
                                </Row>
                            </div>
                            <div className="btn-container">
                                <Button 
                                disabled={!selectedTechnician || isMiniLoading}
                                onClick={()=>assignTech()}
                                >
                                    {lang.assign_this}
                                </Button>
                            </div>
                            </> : null
                            }
                            {  detail.status !== taskStatus.CREATE && detail.status !== taskStatus.CANCEL ?
                                <div className="technician-detail">
                                    <div className="col-title">{lang.technician}</div>
                                        <div className="detail">
                                            { detail.technicianProfileImage ?
                                            <img src={detail.technicianProfileImage} className="technician-image"/>
                                            : <FontAwesomeIcon icon={faUserCircle} className="technician-image"/>
                                            }
                                            <div>
                                                <div className="title"><b>{detail.technicianName}</b></div>
                                                <div>{detail.technicianEmail}</div>
                                                { detail.status === taskStatus.WAITING ?
                                                <>
                                                <div className="col-desc">
                                                    {lang.unassign_desc}
                                                </div>
                                                <Button variant="warning" size="sm"
                                                style={{marginTop: 3}}
                                                onClick={()=>unassignFromTask()}
                                                >
                                                    {lang.unassign}
                                                </Button>
                                                </>
                                                : null
                                                }
                                            </div>
                                        </div>
                                </div>
                                : null
                            }
                            { detail.status === taskStatus.COMPLETE ?
                            <div>
                                <div className="col-title">{lang.get_document}</div>
                                <div className="col-desc">{lang.get_document_desc}</div>
                                <div className="btn-container">
                                    <Button variant="success"
                                    onClick={()=>downloadPdf()}>
                                        {lang.download}
                                    </Button>
                                </div>
                            </div>
                            : null
                            }
                            { detail.status !== taskStatus.CANCEL && detail.status !== taskStatus.COMPLETE ?
                            <div>
                                <div className="col-title">{lang.cancel}</div>
                                <div className="col-desc">{lang.cancel_desc}</div>
                                <div className="btn-container">
                                    <Button variant="danger"
                                    onClick={()=>cancel()}>
                                        {lang.cancel}
                                    </Button>
                                </div>
                            </div>
                            
                            :null
                            }
                            <div>
                                <div className="col-title">{lang.delete}</div>
                                <div className="col-desc">{lang.delete_desc}</div>
                                <div className="btn-container">
                                    <Button variant="danger"
                                    onClick={()=>deleteThisTask()}>
                                        {lang.delete}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
           
        </div>
        </>
    )
}

const DetailRow = (props) =>{
    return(
        <div className="col-detail" 
        style={{
            display: props.detail === "" ||
            props.detail === null || 
            props.detail === 0 ? 'none' : "flex"}}>
            <div style={{flex: 0.4}}>                
                <b>{props.title} : </b>
            </div>
            <div style={{flex: 1}}>
                {props.detail || "None"} 
            </div>
        </div>
    )
}

const TechnicianProfile = (props) =>{

    return(
        <div 
        className="technician-profile"
        style={{
            color: props.isSelected ? "white": "black",
            backgroundColor: props.isSelected ? "#0275d8" : null
        }}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        onClick={props.onClick}>
            { props.imagePath !== "" && props.imagePath !== null ?
            <img src={props.imagePath}
            className="image"/>
            :
            <FontAwesomeIcon 
            icon={faUserCircle}
            className="image-placeholder"
            style={{color: props.isSelected ? "white": "gray"}}
            />
            }
            <div className="title">
                {props.name}
            </div>
        </div>
    )
}


export default RepairDetail
